import { styled } from 'styled-components';

const GapWrapper = styled.div<{
  $gap?: number | { row: number; column: number };
  $row?: boolean;
  $wrap?: 'wrap' | 'nowrap';
  $justify?: 'flex-start' | 'center' | 'space-between' | 'flex-end';
  $align?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
  $width?: 'inherit' | 'unset' | '100%' | 'auto';
}>`
  display: flex;
  flex-direction: ${({ $row }) => {
    return $row ? 'row' : 'column';
  }};
  flex-wrap: ${({ $wrap }) => {
    return $wrap ? $wrap : 'nowrap';
  }};
  align-items: ${({ $align }) => {
    return $align ? $align : 'flex-start';
  }};
  justify-content: ${({ $justify }) => {
    return $justify ? $justify : 'self-start';
  }};
  gap: ${({ $gap, $wrap }) => {
    if (typeof $gap === 'number') {
      return `${$gap}px`;
    } else if (
      $gap &&
      $wrap === 'wrap' &&
      (typeof $gap.row === 'number' || typeof $gap.column === 'number')
    ) {
      const rowGap = typeof $gap.row === 'number' ? $gap.row : 0;
      const columnGap = typeof $gap.column === 'number' ? $gap.column : 0;
      return `${rowGap}px ${columnGap}px`;
    }
    return '0';
  }};

  width: ${({ $width }) => {
    return $width ? `${$width}` : '100%';
  }};
  max-width: 100vw;
`;
export default GapWrapper;
